import Alert from "@mui/material/Alert";
import IconButton from "@mui/material/IconButton";
import Modal from "@mui/material/Modal";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useCallback, useState } from "react";
import { useCancelSubscriptionMutation } from "src/api/services/subscriptionsApi";
import { PatientSubscriptions } from "src/api/types";
import LoadingButton from "src/components/Buttons/LoadingButton/LoadingButton";
import { desktopSx } from "src/utils/styles/modalStyles";
import { Close } from "@mui/icons-material";
import { AlertTitle } from "@mui/material";

interface Props {
  subscription: PatientSubscriptions;
  onClose: () => void;
  open: boolean;
}

const CancelSubscriptionModal = ({ subscription, onClose, open }: Props) => {
  const [error, setError] = useState("");
  const [cancelSubscription, { isLoading }] = useCancelSubscriptionMutation();

  const handleCancel = useCallback(() => {
    setError("");
    cancelSubscription({
      id: subscription.id,
      patientId: subscription.patient_id,
    })
      .unwrap()
      .catch((err) => setError(err.data.message))
      .finally(onClose);
  }, [cancelSubscription, onClose, subscription.id, subscription.patient_id]);

  return (
    <Modal open={open}>
      <Stack sx={desktopSx} gap={2}>
        <Stack direction="row" justifyContent="space-between">
          <Typography fontWeight={700} variant="h5">
            Cancel Plan
          </Typography>
          <IconButton onClick={onClose}>
            <Close fontSize="medium" />
          </IconButton>
        </Stack>
        <Alert severity="error" sx={{ maxWidth: "400px" }}>
          <AlertTitle>{`You are about to cancel ${subscription.display_name}. This action cannot be undone.`}</AlertTitle>
          It will cancel all upcoming orders and tasks. Message thread will also
          be unavailable.
        </Alert>

        <Stack gap={1}>
          {error ? (
            <Typography sx={{ color: "red" }} textAlign="center">
              {error}
            </Typography>
          ) : null}

          <LoadingButton loading={isLoading} onClick={handleCancel}>
            Cancel Plan
          </LoadingButton>
        </Stack>
      </Stack>
    </Modal>
  );
};

export default CancelSubscriptionModal;
